// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IMetaTag } from '@/models/metaTags.model';

// Components
import { Modal, ModalSize } from '@/components';
import { CrossIcon, EditIcon } from '@/icons';
import { COLORS } from '@/theme';
import { Button } from '@/ui';
import { StyledActionButton } from '../Styled';
import { StyledActionsWrap, StyledButtonsWrapper, StyledTitleModal } from './TableActionsStyles';

// Helpers
import { useModal } from '@/hooks';
import { UNDELETED_SLUGS } from '@/modules/MetaTags/helpers/constants';

type TTableActions = {
  record: IMetaTag;
  onEdit: (item: IMetaTag) => void;
  onDelete: (item: IMetaTag) => void;
};

const TableActions = ({ onDelete, onEdit, record }: TTableActions) => {
  const { t } = useTranslation(['metatags']);
  const { isOpened, openModal, closeModal } = useModal();
  const handleEdit = () => onEdit(record);
  const handleDelete = () => onDelete(record);

  return (
    <StyledActionsWrap>
      <StyledActionButton onClick={handleEdit} $color={COLORS.GREEN}>
        <EditIcon />
      </StyledActionButton>
      {!UNDELETED_SLUGS.some((slug) => slug === record.slug) && (
        <StyledActionButton $color={COLORS.RED} onClick={openModal}>
          <CrossIcon />
        </StyledActionButton>
      )}
      <Modal visible={isOpened} onCancel={closeModal} size={ModalSize.LARGE}>
        <StyledTitleModal>{t('metatags_delete_title')}</StyledTitleModal>
        <StyledButtonsWrapper>
          <Button onClick={closeModal} type="primary">
            {t('metatags_delete_cancel')}
          </Button>
          <Button onClick={handleDelete} type="text">
            {t('metatags_delete_ok')}
          </Button>
        </StyledButtonsWrapper>
      </Modal>
    </StyledActionsWrap>
  );
};

export default TableActions;
